module.exports = __webpack_public_path__ + "static/the-rape-of-nanking-b5ad24fa3cd00a09263b65fafb7cfc55.jpg";